var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.l_visible
    ? _c("v-autocomplete", {
        ref: "control",
        staticClass: "dynamic-input-control",
        class: {
          validated:
            _vm.displayValidated && !_vm.hasError && !_vm.errorMessages,
          required: _vm.l_required,
          readonly: _vm.readonly
        },
        attrs: {
          errorMessages: _vm.errorMessages,
          value: _vm.ico,
          outlined: "",
          items: _vm.items,
          loading: _vm.isLoading,
          "hide-no-data": "",
          label: _vm.l_label,
          "append-icon": _vm.isDisabled ? "" : "mdi-chevron-down",
          "search-input": _vm.search,
          clearable: "",
          disabled: _vm.isDisabled,
          rules: _vm.getRules,
          placeholder: _vm.placeholder,
          readonly: _vm.isLoading || _vm.isDisabled,
          "return-object": "",
          "item-text": _vm.itemKey,
          "item-value": "ico"
        },
        on: {
          input: function(newVal) {
            _vm.setDirty(true)
            _vm.update(newVal)
          },
          "update:searchInput": function($event) {
            _vm.search = $event
          },
          "update:search-input": function($event) {
            _vm.search = $event
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item",
              fn: function(ref) {
                var item = ref.item
                return [
                  !_vm.obchodneMeno
                    ? [
                        _c(
                          "div",
                          { staticClass: "d-flex w100" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "ma-0 f18",
                                class: { "pr-5px": item.forma_podn === "PO" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.forma_podn === "PO"
                                      ? "mdi-office-building-outline"
                                      : "mdi-human-male"
                                  )
                                )
                              ]
                            ),
                            _c("div", { staticClass: "d-flex mr-25px" }, [
                              _c(
                                "div",
                                _vm._l(
                                  _vm.generateMaskTextArray(
                                    _vm.search,
                                    item.ico
                                  ),
                                  function(i, index) {
                                    return _c(
                                      "span",
                                      {
                                        key: index,
                                        staticClass: "v-center-text",
                                        class: { "v-list-item__mask": i.mask }
                                      },
                                      [_vm._v(" " + _vm._s(i.text) + " ")]
                                    )
                                  }
                                ),
                                0
                              )
                            ]),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "f14 pl-2px ico-item-cor v-center-text"
                              },
                              [_vm._v(_vm._s(item.nazov))]
                            ),
                            _c("v-icon", { staticClass: "ma-0 pl-25px f18" }, [
                              _vm._v("mdi-map-marker-outline")
                            ]),
                            _c(
                              "span",
                              { staticClass: "f12 pl-5px v-center-text" },
                              [_vm._v(_vm._s(item.adresa))]
                            )
                          ],
                          1
                        )
                      ]
                    : [
                        _c(
                          "div",
                          { staticClass: "d-flex w100" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "f18",
                                class: { "pr-5px": item.forma_podn === "PO" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.forma_podn === "PO"
                                      ? "mdi-office-building-outline"
                                      : "mdi-human-male"
                                  )
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex mr-25px w250px",
                                staticStyle: { overflow: "hidden" }
                              },
                              [
                                _c(
                                  "div",
                                  _vm._l(
                                    _vm.generateMaskTextArray(
                                      _vm.search,
                                      item.nazov
                                    ),
                                    function(i, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          staticClass: "v-center-text",
                                          class: { "v-list-item__mask": i.mask }
                                        },
                                        [_vm._v(" " + _vm._s(i.text) + " ")]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ]
                            ),
                            _c("v-icon", { staticClass: "pl-8px f18" }, [
                              _vm._v("mdi-map-marker-outline")
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "f12 pl-5px v-center-text pr-25px"
                              },
                              [_vm._v(" " + _vm._s(item.adresa) + " ")]
                            ),
                            _c(
                              "div",
                              { staticClass: "v-center-text w70px ml-auto" },
                              [_vm._v(_vm._s(item.ico))]
                            )
                          ],
                          1
                        )
                      ]
                ]
              }
            }
          ],
          null,
          false,
          1644550956
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }